import { render, staticRenderFns } from "./labDataItem.vue?vue&type=template&id=156dbe0f"
import script from "./labDataItem.vue?vue&type=script&lang=ts"
export * from "./labDataItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports